import { FaBullhorn } from "react-icons/fa";
import { useContextData } from "../../../core/context/index";

const HomeAnnouncement = () => {
  const { siteSettings } = useContextData();
  return (
    <section className="container home-announcement-section">
      {/* News  */}
      {/* {<pre>{JSON.stringify(siteSettings, null, 2)}</pre> } */}
      {siteSettings && siteSettings.announcementText ? (
        <div className="py-2 py-md-1">
          <div className="w-100 d-flex justify-content-start align-items-center py-1 gap-2 ">
            <div>
              <span className="news-i">
                <FaBullhorn />
              </span>
            </div>
            <div class="news-slider">
              <marquee>
                <small className="text-nowrap">
                  {siteSettings.announcementText}
                </small>
              </marquee>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </section>
  );
};

export default HomeAnnouncement;